import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import { EpiApiState, epiApiReducerWithDefault } from '../global/ducks/epi-api';
import { IEpiProps } from './state-helpers/epi-props';
import { defaultEpiPropsModel } from './reducers/epi-props-model';
import { fetchMiddleware } from '../global/middleware/fetch-middleware';
import { FilterableListApp } from './components/filterable-list-app';
import { FilterableListApiState, filterableListApiReducer } from '../global/ducks/filterable-list-api';
import { RouterToUrlQuery, addUrlProps, UrlQueryParamTypes, subquery, configureUrlQuery, urlQueryMiddleware } from 'react-url-query';
import { BrowserRouter, Route} from 'react-router-dom';
import { history } from './state-helpers/history';
import { createRoot } from 'react-dom/client';


// State that controls this app
export interface IBaseAppState {
    epi: EpiApiState<IEpiProps>,
    results: FilterableListApiState,
    uniqueUserId: string
}

export const stateReducer = combineReducers<IBaseAppState>({
    epi: epiApiReducerWithDefault({ props: defaultEpiPropsModel }),
    results: filterableListApiReducer
});

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateStore = createStore(stateReducer, composeEnhancers(
    applyMiddleware(
        fetchMiddleware,
        urlQueryMiddleware()
    )
));

configureUrlQuery({ history, addChangeHandlers: false });
const RouterContext = React.createContext({});

//Render the search application by attaching it to the placeholder element search-page-app
const filterableListApp = document.getElementById('filterable-list-app');
const root = createRoot(filterableListApp);

if (filterableListApp) {
    const { contentId, pageTitle, name, email, uniqueUserId, gridclass } = (window as any).bootstrap;
    const requireNameAndEmail = (window as any).bootstrap.requireNameAndEmail as boolean;

    root.render(
        <Provider store={stateStore}>
            <BrowserRouter>
                <Route>
                    {routeProps => (
                        <RouterContext.Provider value={routeProps}>
                            <RouterToUrlQuery routerContext={RouterContext}>
                    <FilterableListApp
                        contentId={contentId}
                        pageTitle={pageTitle}
                        requireNameAndEmail={requireNameAndEmail}
                        name={name}
                        email={email}
                        uniqueUserIdBootstrap={uniqueUserId}
                        gridclass={gridclass}
                    />
                            </RouterToUrlQuery>
                        </RouterContext.Provider>
                    )}
                </Route>
            </BrowserRouter>
        </Provider>)
}